import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CPQPage, CPQScreenOption } from '../../../models/CPQUI';


@Component({
  selector: 'app-cpqpage',
  templateUrl: './cpqpage.component.html',
  styleUrls: ['./cpqpage.component.css']
})
export class CPQPageComponent implements OnInit {
  @Output() ChangeEmitter: EventEmitter<CPQScreenOption> = new EventEmitter();
  @Output() InvalidEmitter: EventEmitter<any> = new EventEmitter();
  @Input() CurrentCPQPage: CPQPage;

  constructor() { }

  ngOnInit(): void {
    if (this.CurrentCPQPage) {

    }
  }

  SetCPQPage(page: CPQPage) {
    this.CurrentCPQPage = page;
  }

  OnScreenChange(event: CPQScreenOption) {
    this.ChangeEmitter.emit(event);
  }

  OnInvalidEmitter(event: string) {
    this.InvalidEmitter.emit(event);
  }
}
